// extracted by mini-css-extract-plugin
module.exports = {"Form":"index-module--Form--1IPMR","Form__submit":"index-module--Form__submit--3XQ8T"};